import { createRoot } from 'react-dom/client'
import './index.css'

const isAdmin = window.location.pathname.startsWith('/admin')

if (isAdmin) {
  import('./Admin.jsx').then(({ default: Admin }) => {
    createRoot(document.getElementById('root')).render(<Admin />)
  })
} else {
  Promise.all([
    import('./App.jsx'),
    import('./lib/auth.jsx'),
  ]).then(([{ default: RecoMenuApp }, { AuthProvider, useAuth }]) => {
    function Root() {
      const auth = useAuth()
      return <RecoMenuApp auth={auth} />
    }
    createRoot(document.getElementById('root')).render(
      <AuthProvider>
        <Root />
      </AuthProvider>
    )
  })
}
